<template>
  <div id='team-rank-cell' v-if='rankData.list.length > 0'>
    <div id='team-rank-section-title' v-if='rankData.type != 0'>{{ $t(`leagueRank.${rankData.type == 1 ? 'east' : 'west'}`) + ' - ' + $t('leagueRank.teamRank') }}</div>
    <div id='team-rank-cell-title'>
      <div>{{ $t('leagueIndex.rank') }}</div>
      <div>{{ $t('playerSeasonStats.team') }}</div>
      <div>{{ $t('teamTrackRecord.win') }}</div>
      <div>{{ $t('teamTrackRecord.lose') }}</div>
      <div>{{ $t('teamTrackRecord.winRatio') }}</div>
    </div>
    <div id='team-rank-cell-row' v-for="(item, index) in rankData.list" :key='item.teamId'>
      <div id='team-rank-cell-row-content' @click='jumpToTeamPage(item.teamId)'>
        <div :class="index < 3 ? 'top-three' : ''">{{ index +1 }}</div>
        <div>{{ $t(`teamName.${item.teamId}`) }}</div>
        <div>{{ item.win }}</div>
        <div>{{ item.lose }}</div>
        <div>{{ (item.winRate * 100).toFixed(1) }}%</div>
      </div>
      <hr/>
    </div>
    <div id='divider'/>
  </div>
</template>>

<script>
import { pageJumpMixin } from '@/views/basketball'

export default {
  name: 'team-rank-cell',
  mixins: [ pageJumpMixin ],
  props: {
    rankData: {
      type: Object,
      required: true,
      default () {
        return {
          type: 0, // 0: hidden, 1: east, 2: west
          list: [
            {
              teamId: 14,
              team: '密尔沃基雄鹿',
              win: 47,
              lose: 8,
              winRate: 0.855
            }
          ]
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~@/styles'

#team-rank-section-title
  padding: 12px 15px
  color: #333333
  font-size: 16px
  font-weight: bold

#team-rank-cell-title, #team-rank-cell-row-content
  padding: 0 15px
  display: flex
  font-size: 12px
  align-items: center

  > div:nth-child(1) // rank
    width: vw(32)

  > div:nth-child(2) // team
    width: vw(148)
    margin-right: 15px

  > div:nth-child(3), & > div:nth-child(4) // win, lose
    width: vw(40)
    margin-right: 5px
    text-align: center

  > div:nth-child(5) // winRatio
    width: vw(60)
    text-align: center

#team-rank-cell-title
  color: #999999
  min-height: 39px
  background-color: #f4f5f8

#team-rank-cell-row-content
  color: #333333
  min-height: 49px

.top-three
  color: #ff3333
  font-weight: bold

#divider
  height: 5px
  background-color: #f5f5f5

</style>
